import { render } from "./BookAppointment.vue?vue&type=template&id=5c8ecaea&scoped=true"
import script from "./BookAppointment.vue?vue&type=script&lang=js"
export * from "./BookAppointment.vue?vue&type=script&lang=js"

import "./BookAppointment.vue?vue&type=style&index=0&id=5c8ecaea&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8ecaea"]])

export default __exports__